import * as Yup from 'yup';

export const RecordSchema = Yup.object()
                               .shape({
                                          reportType: Yup.string()
                                                         .required('Required'),
                                      });
